import styled from 'styled-components';
import { RowFlexContainer } from '../../../../../../stories/atoms/containerV2/ContainerV2';
import { muiTheme, percentToHex } from '../../../../../../theme';

const getHelpASaleMetricColors = (metricName: string): { backgroundColor: string; borderColor: string } => {
  if (metricName === 'sales') {
    return {
      backgroundColor: percentToHex(muiTheme.color.success, 8),
      borderColor: muiTheme.color.validationGreen,
    };
  } else if (metricName === 'conversion') {
    return {
      backgroundColor: muiTheme.color.warningLightTransparent,
      borderColor: muiTheme.color.warningDark,
    };
  } else if (metricName === 'count') {
    return {
      backgroundColor: muiTheme.color.errorLightTransparent,
      borderColor: muiTheme.color.error,
    };
  } else {
    return {
      backgroundColor: muiTheme.color.infoLightTransparent,
      borderColor: muiTheme.color.infoDark,
    };
  }
};

export const HelpASaleCard = styled(RowFlexContainer)<{ metricName: string }>`
  background-color: ${({ metricName }) => getHelpASaleMetricColors(metricName).backgroundColor};
  border: ${({ metricName }) => `1px solid ${getHelpASaleMetricColors(metricName).borderColor}`};
`;
